const http = require('@/utils/http');

/**
 * 广场活动枚举
 * @type {{TAKE_DOWN: number, END: number}}
 */
const ACTIVITY_STATUS = {
  TAKE_DOWN: 3,
  END: 2,
};

module.exports = {
  ACTIVITY_STATUS,
  // 获取广场活动list
  getList(params) {
    return http
      .get('/workscene/workscene/v1/square_activity/merchant/get/list', params)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 获取广场活动详情
  getDetail(params) {
    return http
      .get(
        '/workscene/workscene/v1/square_activity/merchant/get/' + params.id,
        params
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 获取广场活动详情
  getMsgDetail(params) {
    return http
      .post('/workscene/workscene/v1/notice/getDetail', params, {
        'Content-Type': 'application/json;charset=UTF-8;',
      })
      .then(res => {
        if (res.status === 200) {
          if (
            Object.values(ACTIVITY_STATUS).includes(res.data.activityStatus)
          ) {
            const MESSAGE_ENUM = {
              [ACTIVITY_STATUS.TAKE_DOWN]: '活动已下架',
              [ACTIVITY_STATUS.END]: '活动已结束',
            };
            throw {
              message: MESSAGE_ENUM[res.data.activityStatus],
              errCode: res.data.activityStatus,
            };
          } else {
            return res.data;
          }
        } else {
          throw res;
        }
      });
  },

  // 获取广场活动-报名明细
  getRegDetail(params) {
    return http
      .get(
        '/workscene/workscene/v1/square_activity/merchant/detail/list',
        params
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },

  // 添加修改反馈信息
  editDetail(params) {
    const header = {
      'Content-Type': 'application/json;charset=UTF-8;',
    };
    return http
      .post(
        '/workscene/workscene/v1/square_activity/merchant/feedback/add',
        params,
        header
      )
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 获取员工餐或内购会list
  getInsideList(params) {
    return http
      .get('/workscene/workscene/v1/innerWelfare/viewsByPlazaId', params)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  // 获取员工餐或内购会详情
  getInsideDetail(params) {
    return http
      .get('/workscene/workscene/v1/innerWelfare/view/' + params.id, params)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
};
